import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App/App';
import { Provider } from 'react-redux';
import { store } from './App/store';
import { injectStore } from './shared/request';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

injectStore(store);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
